import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import Button from 'react-bootstrap/Button';
import { toast } from "react-toastify";
import ViewFileURL from "../../components/ViewFileURL";
import { Constants } from "../../libs/Constants";
import { update } from "../../libs/dbFunctions";
import { formatCurrency } from "../../libs/utils";

const Approvals = ({ approvals, onSuccess }) => {
    const columns = [
        {
            dataField: "id",
            text: "Id",
            headerClasses: "text-break",
            hidden: true,
        },
        {
            dataField: "userName",
            text: "User Name",
            headerClasses: "text-break",
        },
        {
            dataField: "userEmail",
            text: "Email",
            headerClasses: "text-break",
        },
        {
            dataField: "contributionAmount",
            text: "New Bi-monthly Contribution Amount",
            headerClasses: "text-break",
            formatter: ((cell) => {
                return formatCurrency(cell);
            })
        },
        {
            dataField: "oneTime",
            text: "Is this a one time change?",
            headerClasses: "text-break",
            formatter: ((cell) => {
                if (cell) {
                    return 'Yes';
                } else
                    return 'No';
            })
        },
        {
            dataField: "payStub",
            text: "Pay Stub",
            formatter: (cell) => {
                if (!cell) {
                    return <></>;
                }
                return <ViewFileURL
                    fileName={cell}
                />;
            },
        },
        {
            dataField: "approval",
            text: "New Contribution Approval",
            formatter: (cell, row) => {
                return <>
                    <Button
                        onClick={() => handleApproval(row, true)}
                        variant="primary"
                    >
                        Approve
                        </Button>
                    <Button
                        onClick={() => handleApproval(row, false)}
                        variant="outline-cancel"
                    >
                        Reject
                        </Button>
                </>
            }
        }
    ];

    const handleApproval = async (row, flag) => {
        console.log('handleApproval', row, flag);
        let saveFields = {
            ...row,
            approvalStatus: flag,
        };
        //update the approval status
        try {
            await update(Constants.dbTypes.APPROVAL_REQUEST, saveFields);
            toast.success('Request Status is updated.');
            onSuccess();
        } catch (e) {
            toast.error("Failed to save approval status.");
        }
    }
    return (
        <div>
            <BootstrapTable
                bootstrap4={true}
                id="id"
                wrapperClasses="table-fixed-height"
                classes="table-taabl table-document"
                keyField="id"
                bordered={false}
                data={approvals}
                noDataIndication={() => <div>No data found</div>}
                columns={columns}
            />
        </div>
    );
};

export default Approvals;
